import useTransparentLogo from '../hooks/useTransparentLogo';

// Nav: contorno blanco fino — separa el texto oscuro del fondo azul oscuro
const filterNav = [
  'drop-shadow(-1px  0px 0 rgba(255,255,255,0.75))',
  'drop-shadow( 1px  0px 0 rgba(255,255,255,0.75))',
  'drop-shadow( 0px -1px 0 rgba(255,255,255,0.75))',
  'drop-shadow( 0px  1px 0 rgba(255,255,255,0.75))',
].join(' ');

export default function MonodepinLogo() {
  const src = useTransparentLogo();
  return (
    <img
      src={src}
      alt="Mondepin"
      className="h-9 w-auto"
      style={{ filter: filterNav, imageRendering: 'auto' }}
    />
  );
}
